import * as angular from "angular";
import {IController} from "angular";
import {DashboardModel} from "../../models/dashboard.model";
import {WidgetModel} from "../../models/widget.model";

export class DashboardFormComponent implements IController {

  dashboard: DashboardModel;
  isCopyDashboard: boolean;
  onClose: Function;
  onSave: Function;

  onBranchesChange(branchIds: string[]) {
    this.dashboard.branchIds = branchIds;
  }

  onSubmit(form) {
    form.$setSubmitted(true);
    if (form.$valid) {

      this.dashboard.widgetViewConfigurations.forEach(w => {
        if (w.filters.branchIds?.length) {
          w.filters.branchIds = w.filters.branchIds.filter(id => this.dashboard.branchIds?.includes(id));
        }
      })

      this.onSave({dashboard: this.dashboard})
    }
  }

}

angular
  .module('bringoz.admin.dashboards')
  .component('dashboardForm', {
    bindings: {
      dashboard: '<',
      isCopyDashboard: '<?',
      onClose: '&',
      onSave: '&'
    },
    template: require('./dashboard-form.html').default,
    controller: DashboardFormComponent
  });
